import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Switcher.scss';


export class Switcher extends Component {
  render(){
    const { className, theme, enabled, onChange, ...otherProps } = this.props;
    return (
      <label onClick={onChange} {...otherProps} className={cn({
        [className]: true,
        [styles.switcher]: true,
        [styles.switcherEnabled]: enabled,
      })}>
        <i className={styles.switcherButton} style={{ backgroundColor: enabled ? theme : null }}/>
      </label>
    );
  }
}
